import axios from 'axios';
import { Message, Notification } from 'element-ui';
import store from '@/public/store';
import { getToken } from '@/web-framework/api/token';
import router from '@/public/router';
import UserAPI from '@/web-framework/api/user.js';
axios.defaults.headers.post['Content-Type'] = 'application/json';

const service = axios.create({
    baseURL: '/api',
    withCredentials: true,
    timeout: 50000
});

service.interceptors.request.use(
    config => {
        config.headers['wi'] = Constants.WEB_ID;
        let token = localStorage.getItem('admin-token');
        if (token) {
            config.headers['authorization'] = token;
        }
        if (UserAPI.haveRole()) {
            config.headers['rid'] = UserAPI.getUserRole().id;
        }
        // 获取当前路由名称
        if (router.app._route.name && router.app._route.name.length > 0) {
            config.headers['model'] = router.app._route.name;
        }
        if (store.getters.currentOrgan && store.getters.currentOrgan.id && store.getters.currentOrgan.id.length > 0) {
            config.headers['organ_id'] = store.getters.currentOrgan.id;
        }
        if (Constants.APP_ID && Constants.APP_ID.length > 0) {
            config.headers['app_id'] = Constants.APP_ID;
        }
        return config;
    },
    error => {
        return Promise.resolve({
            success: false,
            code: -1,
            message: error || '网络出了点意外，请稍后'
        });
    }
);

service.interceptors.response.use(
    response => {
        const res = response.data;
        if (!res.success) {
            return Promise.resolve({
                ...res
            });
        } else {
            if (typeof res.code != 'undefined' && res.code == 11111) {
                // Notification.warning({ title: '操作失败', message: result.message });
                Notification.warning({
                    title: '敏感操作提示',
                    message: '此操作为敏感操作，演示站已屏蔽了此次操作对系统造成的影响，数据的返回或所执行的操作均为虚拟操作。您可对数据进行随意操作，不影响系统的安全同时，也不影响您对功能的体验。'
                });
            }
            return res;
        }
    },
    error => {
        Message({
            message: error.message || '网络出了点意外，请稍后',
            type: 'error',
            duration: 5 * 1000
        });
        return Promise.resolve({
            success: false,
            code: -1,
            message: error.message || '网络出了点意外，请稍后'
        });
    }
);

window.Request = {
    delete: function (vm, url, deleteCallback) {
        vm.$confirm('确定删除此数据吗？', '删除确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            if (typeof vm.listLoading != 'undefined') {
                vm.listLoading = true;
            }
            Request.get(url)
                .then(result => {
                    if (
                        !result.success &&
                        (result.code == -22 ||
                            result.code == -23 ||
                            result.code == -24)
                    ) {
                        window.location = '/';
                        return;
                    }
                    if (typeof vm.listLoading != 'undefined') {
                        vm.listLoading = false;
                    }
                    if (result.success) {
                        vm.$message.success('删除成功');
                        if (deleteCallback) deleteCallback();
                    } else if (result.message) {
                        vm.$message.error(result.message);
                    } else {
                        vm.$message.error('删除失败');
                    }
                })
                .catch(error => {
                    if (typeof vm.listLoading != 'undefined') {
                        vm.listLoading = false;
                    }
                    vm.$message.error('删除失败');
                });
        });
    },
    search: function (vm, url, data) {
        if (typeof vm.listLoading != 'undefined') {
            vm.listLoading = true;
        }
        let _data = typeof vm.listQuery == 'undefined' ? {} : vm.listQuery;
        return new Promise((resolve, reject) => {
            Request.post(url, _data)
                .then(result => {
                    if (
                        !result.success &&
                        (result.code == -22 ||
                            result.code == -23 ||
                            result.code == -24)
                    ) {
                        window.location = '/';
                        return;
                    }

                    if (typeof vm.listLoading != 'undefined') {
                        vm.listLoading = false;
                    }
                    if (result.success) {
                        if (typeof vm.tableDatas != 'undefined') {
                            vm.tableDatas = result.data;
                            Vue.set(vm, 'tableDatas', result.data);
                            if (typeof vm.listQuery != 'undefined') {
                                vm.listQuery = {
                                    ...vm.listQuery,
                                    ...result.page
                                };
                            }
                        }
                    } else if (result.message) {
                        vm.$message.error(result.message);
                    } else vm.$message.error('数据加载失败');
                    resolve();
                })
                .catch(error => {
                    if (typeof vm.listLoading != 'undefined') {
                        vm.listLoading = false;
                    }
                    vm.$message.error('数据加载失败');
                    reject();
                });
        });
    },
    upload: (url, data) => {
        return new Promise((res, rej) => {
            service({
                url: url,
                headers: {
                    'Content-type': 'application/json'
                },
                method: 'post',
                data
            })
                .then(result => {
                    if (
                        !result.success &&
                        (result.code == -22 ||
                            result.code == -23 ||
                            result.code == -24)
                    ) {
                        window.location = '/';
                        return;
                    }
                    res(result);
                })
                .catch(err => {
                    rej(err);
                });
        });
    },
    post: (url, data) => {
        return new Promise((res, rej) => {
            service({ url: url, headers: { 'Content-type': 'application/json' }, method: 'post', data })
                .then(result => {
                    if (
                        !result.success &&
                        (result.code == -22 ||
                            result.code == -23 ||
                            result.code == -24)
                    ) {
                        window.location = '/';
                        return;
                    }
                    res(result);
                })
                .catch(err => {
                    rej(err);
                });
        });
    },
    get: (url, data) => {
        return new Promise((res, rej) => {
            service({
                url: url,
                method: 'get',
                headers: {
                    'Content-type': 'application/json'
                },
                params: data
            })
                .then(result => {
                    if (
                        !result.success &&
                        (result.code == -22 ||
                            result.code == -23 ||
                            result.code == -24)
                    ) {
                        window.location = '/';
                        return;
                    }
                    res(result);
                })
                .catch(err => {
                    rej(err);
                });
        });
    },
    delete: (url, data) => {
        return new Promise((res, rej) => {
            service({
                url: url,
                method: 'delete',
                headers: {
                    'Content-type': 'application/json'
                },
                params: data
            })
                .then(result => {
                    if (
                        !result.success &&
                        (result.code == -22 ||
                            result.code == -23 ||
                            result.code == -24)
                    ) {
                        window.location = '/';
                        return;
                    }
                    res(result);
                })
                .catch(err => {
                    rej(err);
                });
        });
    },
    async download(url,filename) {
        try {
            const response = await axios({
                baseURL: '/api',
                method: 'get',
                url: url,
                responseType: 'blob' // 关键部分：设置响应类型为blob
            });

            const blob = new Blob([response.data], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = (typeof filename == 'undefined' ? 'example.txt' : filename) ; // 设置下载文件的名称
            link.click();

            // 释放URL对象
            window.URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error('Error downloading the file:', error);
        }
    },
    validateResult(result, fn) {
        if (result && result.success) {
            fn();
        } else if (result && result.message) {
            Notification.warning({ title: '操作失败', message: result.message });
        } else {
            Message.error('操作失败');
        }
    },
    validateCatchError(error) {
        if (error && error.message) {
            Notification.warning({ title: '操作失败', message: error.message ? error.message : '请检查您的网络或刷新页面后重试！' });
        } else {
            Message.error('操作失败');
        }
    }
};
export default {
    service,
    Request
};